
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiBuoySphericalSouth as ObiBuoySphericalSouthElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-buoy-spherical-south.js';
 
 
 

 
 export const ObiBuoySphericalSouth = createComponent({
   react: React,
   tagName: 'obi-buoy-spherical-south',
   elementClass: ObiBuoySphericalSouthElement,
   events: {
     
   }
  });
 
 